import React from 'react';
import { Neo } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import InterestRateCalculationTypesVM from '../InterestRateCalculationTypesVM';
import InterestRateCalculationType from '../../../Models/Rates/InterestRateCalculationType';
import { InterestCalculationType } from '../../../Models/Rates/InterestCalculationType.enum';
import { EnumHelper } from '@singularsystems/neo-core';

export interface IInterestRateCalculationTypeEditComponentProps {
    viewModel: InterestRateCalculationTypesVM;
    interestRateCalculationType: InterestRateCalculationType;
}

@observer
export class InterestRateCalculationTypeEditComponent extends React.Component<IInterestRateCalculationTypeEditComponentProps> {

    public render() {
        const { viewModel, interestRateCalculationType } = this.props;

        return (
            <>
                <Neo.Form model={interestRateCalculationType} showSummaryModal onSubmit={() => viewModel.saveInterestRateCalculationType()}>
                    <div className="d-flex justify-content-between mb-4">
                        <Neo.Button icon="arrow-left" variant="light" className="min-width" onClick={() => viewModel.editingInterestRateCalculationType = null}>Back</Neo.Button>
                        <Neo.Button isSubmit icon="save" pulse={interestRateCalculationType.readyToSave}>Save</Neo.Button>
                    </div>

                    <Neo.GridLayout xl={2}>
                        <Neo.Card title="Calculation Type">
                            <Neo.FormGroupInline
                                bind={interestRateCalculationType.meta.interestCalculationType}
                                disabled={!interestRateCalculationType.isNew}
                                label="For Calculation Type"
                                select={{ items: EnumHelper.asList(InterestCalculationType) }} />
                            {interestRateCalculationType.interestCalculationType === InterestCalculationType.Zaronia &&
                                <Neo.FormGroupInline bind={interestRateCalculationType.meta.includeSpreadInMargin} footerText="Includes the credit adjustment spread with the investment rate in Zaronia accruals." />
                            }
                            <Neo.FormGroupInline bind={interestRateCalculationType.meta.calculationName} />
                            <Neo.FormGroupInline bind={interestRateCalculationType.meta.description} input={{ rows: 3 }} />
                            <Neo.FormGroupInline bind={interestRateCalculationType.meta.formula} footerText="See the formula variables section" />
                            <Neo.FormGroupInline bind={interestRateCalculationType.meta.ordinal} />
                        </Neo.Card>

                        <Neo.Card title="Formula variables">
                            <p>
                                The following variables can be used in the formula field.
                                When the accrual processor uses your calculation, it will substitute these variables for values as it calculates the amount accrued at each date.
                            </p>

                            <table className='table table-bordered'>
                                <tr>
                                    <th style={{ width: "105px" }}><strong>Variable Name</strong></th>
                                    <th style={{ width: "145px" }}><strong>Short Description</strong></th>
                                    <th><strong>Full Description</strong></th>
                                </tr>
                                <tr>
                                    <td>D</td>
                                    <td>No of days</td>
                                    <td>The days between the Previous Date, and the Current Date.</td>
                                </tr>
                                <tr>
                                    <td>T</td>
                                    <td>Tax Rate</td>
                                    <td>The Tax Rate at the Calculation Date.</td>
                                </tr>
                                <tr>
                                    <td>IR</td>
                                    <td>Interest Rate</td>
                                    <td>The Bank Rate or Jibar Rate at the Current Date. For Fixed Rate calculations it will be 1.</td>
                                </tr>
                                <tr>
                                    <td>RR</td>
                                    <td>Investment Rate</td>
                                    <td>The current investment specific rate. Where the Interest Type is ZARONIA, this is the applicable margin.</td>
                                </tr>
                                {interestRateCalculationType.interestCalculationType === InterestCalculationType.Linear &&
                                    <tr>
                                        <td>CR</td>
                                        <td>Combined Rate</td>
                                        <td>The combined interest and investment rate. The rate is combined according to the interest rate type (added or multiplied).</td>
                                    </tr>}
                                {interestRateCalculationType.interestCalculationType === InterestCalculationType.Zaronia &&
                                    <tr>
                                        <td>S</td>
                                        <td>Credit Adjustment Spread</td>
                                        <td>Where the Interest Type is ZARONIA, this is the applicable credit adjustment spread.</td>
                                    </tr>}
                                {interestRateCalculationType.interestCalculationType === InterestCalculationType.Zaronia &&
                                    <tr>
                                        <td>NCCR</td>
                                        <td>Non-Cumulative Compound Rate</td>
                                        <td>Where the Interest Type is ZARONIA, this is the non-cumulative compound rate.</td>
                                    </tr>}
                            </table>
                        </Neo.Card>
                    </Neo.GridLayout>
                </Neo.Form>
            </>
        )
    }
}